// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".theme--dark.v-btn.v-btn--disabled[data-v-2e53c08b]{color:#fff!important}", "",{"version":3,"sources":["webpack://./resources/js/Sections/Order/TopBar.vue"],"names":[],"mappings":"AACA,oDACE,oBAAF","sourcesContent":["\n.theme--dark.v-btn.v-btn--disabled {\n  color: white !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
